import * as en from "./en"
import * as ko from "./ko"

export default {
  en,
  ko,
}
